import React, { FC, useRef } from "react"
import { observer } from "mobx-react-lite"

import { Text, StatusBar, Icon, Box, Button, ButtonIcon, ScrollView, HStack, VStack, Actionsheet, ActionsheetContent, ActionsheetDragIndicatorWrapper, ActionsheetDragIndicator, ActionsheetBackdrop } from "@gluestack-ui/themed"
import { MaterialIcons, Ionicons, Zocial } from "@expo/vector-icons";
import { HomeStackParamList, useBackButtonHandler } from "../../navigators"
import { DrawerScreenProps } from "@react-navigation/drawer"
import { useStores } from "../../models"
import { ITEM_STATUS } from "../../voolks/types";
import { getIconItem, getItemTitle, } from "../../utils/itemCommonFunctions";
import { GetActionButtonsFC } from "./sections/GetActionButtonsFC";
import { FieldsList } from "../../components/FieldsList";
import { customApp } from "../../config";
import * as Storage from "../../utils/storage";
import { Alert, Platform, Pressable, TouchableOpacity, View, findNodeHandle, useWindowDimensions } from "react-native";
import { ModalFull, ActionButton } from "../../components";
import PrinterDialog from "../PrinterDialog";
import { Spacer } from "native-base";
import { useDebouncedCallback } from "use-debounce";
import { generarHash } from "../../utils/general";

function _getScreenName(isPTW: boolean, formType: string, defaultName: string) {
  if (formType === "ptw") {
    return "PTWHome";
  }
  if (formType === "workflow") {
    return "WFHome";
  }
  if (formType === "measurement") {
    return "MeasurementHome";
  }
  return defaultName;
}


const sanitizeAndExtractValues = (formData) => {
  if (!formData) return {};

  return Object.keys(formData).reduce((acc, key) => {
    const val = formData[key]?.value;

    // 1. Nulos o indefinidos
    const isNullOrUndefined = val === null || val === undefined;

    // 2. Cadenas vacías o con puros espacios
    const isEmptyString = typeof val === 'string' && val.trim() === '';

    // 3. Booleanos en false (ideal para checkboxes)
    //const isFalse = typeof val === 'boolean' && val === false;

    // 4. Arrays vacíos []
    const isEmptyArray = Array.isArray(val) && val.length === 0;

    // Solo guardamos si pasa TODAS las reglas (no está vacío ni es false)
    if (!isNullOrUndefined && !isEmptyString && !isEmptyArray) {
      acc[key] = val;
    }

    return acc;
  }, {});
};



export const ItemDetailsScreen: FC<DrawerScreenProps<HomeStackParamList, "ItemDetails">> = (function ItemDetailsScreen({ navigation, route }) {
  const TAG_NAME = "ItemDetailsScreen";
  const [shouldHide, setShouldHide] = React.useState(false);
  const [showTemplateList, setShowTemplateList] = React.useState(false);
  const [canScroll, setCanScroll] = React.useState(false)
  const [showPrintDialog, setShowPrintDialog] = React.useState(false);
  const [hasNotif, setHasNotif] = React.useState(undefined);
  const [formView, setFormView] = React.useState<any>(<VStack></VStack>);
  const scrollRef = useRef(null);
  const fieldRefs = useRef(new Map());
  const dimensions = useWindowDimensions();

  useBackButtonHandler(() => () => console.log("Omitir atras"));
  if (shouldHide)
    return <></>;
  const { formsStore, itemsStore, statusStore } = useStores();
  const department = React.useMemo(() => formsStore.mySubscriptions().subscriptions.find((item: any) => item.id == route.params.deptId), []);
  if (department == undefined) {
    navigation.navigate("Settings");
    return <><Text></Text></>
  }
  const form = department.forms.find((form: any) => form.id == route.params.formId);
  if (form == undefined) {
    navigation.navigate("FormsList", { deptId: department.id });
    return <><Text></Text></>
  }
  form.elementsTemplate = {
    flexDirection: "column",
  }

  const oldPayloadHash = useRef(null);
  if (oldPayloadHash.current == null && ["ptw", "workflow"].includes(form.type) && itemsStore.itemActive.status == ITEM_STATUS.draft && itemsStore.itemActive.stepNumber != null && itemsStore.itemActive.stepNumber >= 0) {
    generarHash(JSON.stringify(sanitizeAndExtractValues(itemsStore.itemActive.payload.toJSON()))).then((hash) => {
      oldPayloadHash.current = hash;
      console.log("old Item ", oldPayloadHash.current);
    })
  }

  const formWithOutRevision = form.withoutRevision == true;

  const ItemsListScreenName = _getScreenName(customApp.isPTW, form.type, "ItemsList");
  const FormsListScreenName = _getScreenName(customApp.isPTW, form.type, "FormsList");

  const taskId = route.params.taskId;

  const [pageActive, setPageActive] = React.useState<number>(route.params.pageActive ?? 0);
  if (itemsStore.itemActiveIDX == undefined || itemsStore.itemActive == null || itemsStore.itemActive.payload == null) {
    navigation.navigate(FormsListScreenName);
    return <></>;
  }

  if (route.params.forReview != true && itemsStore.itemActive.status != "draft")
    // @ts-ignore
    navigation.navigate(ItemsListScreenName, { deptId: department.id, formId: form.id, taskId, itemlistStatus: route.params.itemlistStatus });
  const lstTemplates = itemsStore.myTemplates().filter(tpl => tpl.formId == form.id);
  const saveAndGo = async ({ goTo = "", itemStatus = undefined, forReview = false } = {}) => {
    console.log("saveAndGo")
    if (itemStatus != undefined)
      await itemsStore.saveItemActive(itemStatus);
    if (goTo == "") {
      goTo = ItemsListScreenName;
      const itemStatus = itemsStore.itemActive.status;
      if (itemStatus == ITEM_STATUS.draft && route.params.forReview) {
        goTo = "ItemDetails";
        forReview = false;
      }
      if (goTo == ItemsListScreenName && itemStatus == ITEM_STATUS.draft && oldPayloadHash.current != null) {
        const hash = await generarHash(JSON.stringify(sanitizeAndExtractValues(itemsStore.itemActive.payload.toJSON())));
        console.log("new Item ", hash, oldPayloadHash.current);
        if (hash != oldPayloadHash.current) {
          statusStore.setAlertMessage("Atención: Cambios en borrador",
            "Este registro sigue en borrador. Si vuelve a la lista sin bloquearlo o subirlo, la sincronización descargará la versión del servidor y perderá sus modificaciones.",
            [{
              name: "Ir al listado",
              callback: async () => { navigation.navigate(goTo, { deptId: department.id, formId: form.id, forReview, taskId, itemlistStatus: route.params.itemlistStatus }) }
            }]);
          return;
        }
      }
    }
    if (goTo == "ItemDetails") {
      setFormView(<></>);
      setPageActive(0);
    }
    // @ts-ignore
    navigation.navigate(goTo, { deptId: department.id, formId: form.id, forReview, taskId, itemlistStatus: route.params.itemlistStatus })

  }

  let leftButton = <Button width={50} height={50} p="$1" variant="solid" key="actionButton-nextPage" onPress={() => saveAndGo({ itemStatus: (itemsStore.itemActive.status) })}>
    <ButtonIcon as={Ionicons} name="arrow-back" fontWeight="$extrabold" size="xl" color="#FFF" />
  </Button>;
  const IconItemStatus: FC = observer(function iconItemStatus() {
    return getIconItem(itemsStore.itemActive.status, undefined, "sm");
  })
  const applyTemplate = (tpl) => {
    setFormView(<></>);
    itemsStore.replacePayloadActive(tpl.payload.toJSON());
    setTimeout(makeForm, 2000);
  }
  const moveToPage = (pageTo: number,) => {
    setPageActive(pageTo);
  }
  const moveToPageDebounced = useDebouncedCallback(moveToPage, 500);

  const navigatePages = (withTitles: boolean) => {
    return form.pages.length > 1 ? <>
      <ActionButton
        key="actionButton-nextPage"
        withTitles={withTitles}
        isValidItem={true}
        iconName="caret-forward"
        iconFamily={Ionicons}
        title="Siguiente"
        onPress={() => { moveToPageDebounced(pageActive + 1); }}
        isDisabled={pageActive == (form.pages.length - 1)}
      />
      <ActionButton
        key="actionButton-prevPage"
        withTitles={withTitles}
        isValidItem={true}
        iconName="caret-back"
        iconFamily={Ionicons}
        title="Atras"
        onPress={() => { moveToPageDebounced(pageActive - 1); }}
        isDisabled={pageActive == 0}
      />
    </>
      : <></>
  }

  const makeForm = () => {
    setFormView(<>

      <VStack key="itemDetails-VStackItems" bg="$white" flex={1}>
        <FieldsList itemsStore={itemsStore} setItemRef={setItemRef} scrollToItem={scrollToItem}
          fields={form.pages[pageActive]?.fields} elementsTemplate={form.elementsTemplate}
          forReview={route.params.forReview} scroll={true} statusStore={statusStore} />
        <Spacer></Spacer>
        <VStack backgroundColor="$primary400" style={{ marginTop: 50 }}>
          <HStack key="bottomBar" alignItems="center" style={{ flexDirection: 'row-reverse', paddingRight: "3", }}>
            <GetActionButtonsFC itemsStore={itemsStore} formsStore={formsStore} statusStore={statusStore}
              pageActive={pageActive}
              navigation={navigation}
              setShouldHide={setShouldHide}
              form={form}
              saveAndGo={saveAndGo}
              forReview={route.params.forReview}
              formWithOutRevision={formWithOutRevision}
              ItemsListScreenName={ItemsListScreenName}
              withTitles={true}
            />
            {
              navigatePages(true)
            }
          </HStack>
        </VStack>
      </VStack>

    </>)
  }

  const checkNotif = async () => {
    if (itemsStore.itemActive.id) {
      const data = await Storage.load("notif-".concat(itemsStore.itemActive.id));
      setHasNotif(data);
      console.log("notif", data);
    }
  }
  const printMe = async () => {
    setShowPrintDialog(true);
  }
  const setItemRef = (ref, id) => {
    fieldRefs.current.set(id, ref);
  };
  const scrollToItem = (targetRef: React.ComponentRef<typeof View> | null) => {
    const scrollNode = findNodeHandle(scrollRef.current);
    if (!scrollNode || !targetRef?.measureLayout) return;

    targetRef.measureLayout(
      scrollNode,
      (_x, y) => scrollRef.current?.scrollTo({ y, animated: true }),
      () => console.warn("No se pudo desplazar hasta el inicio del SimpleList.")
    );
  };

  React.useEffect(() => {
    makeForm();
  }, [pageActive, route.params, hasNotif, itemsStore.itemActive.status])

  React.useEffect(() => {
    checkNotif();
  }, []);

  const moveScrolltoStep = () => {
    try {
      console.log("moveScrolltoStep", scrollRef.current != undefined);
      if (scrollRef.current) {
        if (form.workflow?.scrollToStep && itemsStore.itemActive.stepNumber != undefined && itemsStore.itemActive.stepNumber >= 0) {
          statusStore.setStatus("pending");
          if (scrollRef.current.lastPosition == null)
            statusStore.addLoadingInfo({ title: "Cargando estructura de campos del formulario", spinner: true })

          const SCROLL_TO_ITEM_ID = form.workflow.steps[itemsStore.itemActive.stepNumber].checkStepON;

          const targetRef = fieldRefs.current.get(SCROLL_TO_ITEM_ID);
          const scrollNode = findNodeHandle(scrollRef.current);
          const targetNode = findNodeHandle(targetRef);

          if (scrollNode && targetNode) {
            targetRef.measureLayout(
              scrollNode,
              (x, y, width, height) => {
                console.log(`moveScrolltoStep: Componente ${SCROLL_TO_ITEM_ID} encontrado en Y: ${y}`);
                if (y == 0) {
                  setCanScroll(true);
                  statusStore.setStatus("done");
                  return;
                }
                if (scrollRef.current.lastPosition == null || (scrollRef.current.lastPosition != y)) {
                  scrollRef.current.lastPosition = y;
                  moveScrolltoStepDebounced();
                  return;
                }
                console.log(`moveScrolltoStep: Componente ${SCROLL_TO_ITEM_ID} NO se movio Y: ${y} - ${scrollRef.current.lastPosition}`);
                scrollRef.current.scrollTo({
                  y: y,
                  animated: false,
                });
                setCanScroll(true);
                statusStore.setStatus("done");
              },
              () => {
                statusStore.setFlashMessage('error', 'moveScrolltoStep: Fallo al medir el componente');
                setCanScroll(true);
                statusStore.setStatus("done");
              }
            );
          } else {
            setCanScroll(true);
            statusStore.setStatus("done");
          }
          return;
        }
        if (canScroll == false) {
          setCanScroll(true);
          scrollRef.current.scrollTo({ y: 0, animated: false });
        }


      } else {
        console.log("moveScrolltoStep: no tiene scroll ref", scrollRef.current);
      }
    } catch (e) {
      console.log("moveScrolltoStep: error", e);
      setCanScroll(true);
      statusStore.setStatus("done");
    }
  }
  const moveScrolltoStepDebounced = useDebouncedCallback(moveScrolltoStep, 300);

  React.useEffect(() => {
    console.log("useEffect formView", scrollRef.current.callScrollToStep)

    if (scrollRef.current && pageActive == 0 && scrollRef.current.callScrollToStep != true) {
      console.log("useEffect formView", "debounced", scrollRef.current.callScrollToStep)
      scrollRef.current.callScrollToStep = true;
      moveScrolltoStepDebounced();

    }
  }, [formView]);


  return <VStack height="$full">
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box bg="$primary400" />
    <HStack key="itemDetails-title" bg="$primary400" px={0} py={0} justifyContent="space-between" alignItems="center" w="100%">
      <HStack key="headerBar" alignItems="center" style={{ flexDirection: 'row', flex: 0.8 }} maxWidth={statusStore.windowDimensions.width - 140}>
        {leftButton}
        <View style={{ flexDirection: 'row', flex: 1 }}>
          <Text color="$white" fontSize={18} style={{ flexWrap: 'wrap', overflow: "hidden", minWidth: "50%" }}>
            {form.name}
          </Text>
        </View>
      </HStack>
      <HStack key="secondBar" alignItems="center" style={{ flexDirection: 'row-reverse', flex: 0.2, paddingRight: "3" }}>
        <GetActionButtonsFC itemsStore={itemsStore} formsStore={formsStore} statusStore={statusStore}
          pageActive={pageActive}
          navigation={navigation}
          setShouldHide={setShouldHide}
          form={form}
          saveAndGo={saveAndGo}
          forReview={route.params.forReview}
          formWithOutRevision={formWithOutRevision}
          ItemsListScreenName={ItemsListScreenName}
        />
        {navigatePages(false)}
      </HStack>
    </HStack>
    <HStack key="itemDetails-subTitle" bg="$primary300" px={2} py={1} alignItems="center" w="100%">
      <Text><IconItemStatus /></Text><Text color="$white" fontSize="$2xs">{getItemTitle(form, itemsStore.itemActive)} {form.pages.length > 2 ? "".concat(pageActive + 1, "/", form.pages.length) : ""}</Text>
      <View />
      {itemsStore.itemActive.taskId ? <Icon name="event" size="md" color={"secondary.400"} as={MaterialIcons} /> : <></>}
      {hasNotif != undefined ? <Pressable onPress={() => { statusStore.setAlertMessage(hasNotif.notification.title, hasNotif.notification.body) }}>
        <Icon as={Ionicons} name="notifications-circle" size="md" color="yellow.400" />
      </Pressable> : <></>}
      <Spacer />
      {lstTemplates.length > 0 ?
        <Pressable onPress={() => { setShowTemplateList(true) }}>
          <HStack>
            {Platform.OS == "web" ? <Text size="md" color="$white">Mis Plantillas</Text> : <></>}
            <Icon as={MaterialIcons} name="collections-bookmark" size="md" color="$orange500" />
          </HStack>
        </Pressable>
        : <></>
      }
    </HStack>
    <ScrollView scrollEnabled={canScroll} key="itemDetails-scrollItems" ref={scrollRef} keyboardShouldPersistTaps="handled" contentContainerStyle={{ flexGrow: 1 }} flex={1} bgColor="#fff">
      {formView}
    </ScrollView>

    {showPrintDialog ? <ModalFull
      visible={showPrintDialog}
      title="Comprobante Móvil"
      closeButton_onPress={() => { setShowPrintDialog(false); }}
      footer={<></>
      }>
      <View width="100%" height="100%" bgColor={"white"} alignSelf={"center"} borderWidth={1}>
        <PrinterDialog form={form}></PrinterDialog>
      </View>
    </ModalFull>
      : null}
    <Actionsheet isOpen={showTemplateList} onClose={() => setShowTemplateList(false)}>
      <ActionsheetBackdrop />
      <ActionsheetContent>
        <ActionsheetDragIndicatorWrapper>
          <ActionsheetDragIndicator />
        </ActionsheetDragIndicatorWrapper>
        <Box w="100%" h={30} px={4} justifyContent="center" >
          <Text fontSize={16} color="$gray500" bold={true}>
            Completar formulario con un de las siguientes plantillas:
          </Text>
        </Box>
        <VStack>
          {lstTemplates.map((tpl, idx) => (
            <HStack w={statusStore.windowDimensions.width - 20} borderBottomColor="#CCC" borderBottomWidth={1}>
              <Pressable onPress={() => applyTemplate(tpl)}>
                <Text>{tpl.templateName}</Text>
              </Pressable>
              <Spacer></Spacer>
              <Pressable onPress={() => {
                itemsStore.rmTemplate(idx);
                lstTemplates.splice(idx, 1);
                setShowTemplateList(false);
              }}>
                <Icon as={Ionicons} name="trash-outline" size="md" color="$red400" />
              </Pressable>
            </HStack>
          ))
          }

        </VStack>
      </ActionsheetContent>
    </Actionsheet>

  </VStack>
})